(function() {
    'use strict';
    angular
        .module('portalApp')
        .factory('ApplicationFeatureUserGroupMap', ApplicationFeatureUserGroupMap);

    ApplicationFeatureUserGroupMap.$inject = ['$resource'];

    function ApplicationFeatureUserGroupMap ($resource) {
        var resourceUrl =  'api/application-feature-user-group-maps/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
